// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".account[data-v-426d264a]{cursor:pointer}#my-account[data-v-426d264a]{z-index:1000;position:fixed;top:0;right:0;bottom:0;left:0}#my-account[data-v-426d264a] a{color:#666}#my-account.account-form .content[data-v-426d264a]{width:280px;top:120px;right:0;padding:30px;background:white;position:absolute;box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1)}\n", ""]);
// Exports
module.exports = exports;
